/**
 * @param {string} color1 - loalized object - key is locale. e.g {"en": "Value that should be returned"}
 * @param {string} currentLang - language code e.g. 'sk', 'en', 'cz'
 * @returns {string}
 */
export const getValueFromLocalizedObject = (source, currentLang, notFoundLabel = '') => {
    if (typeof source !== 'object' || Object.keys(source).length === 0) {
        return notFoundLabel;
    }

    if (source[currentLang]) {
        return source[currentLang];
    }

    return source.en || source[Object.keys(source)[0]];
};
